import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  useLocation,
  useNavigate,
  Outlet,
  useSearchParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setLanguage } from '../Store/Language';
import { closeTermsModal } from '../Store/uiSlice';

// components
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import TermsModal from '../Components/TermsModal';

import HeroImage from '../Assets/Images/hero.jpg';
import Hero from './components/Hero';
import HeroSection from './components/Hero';

const LayoutWithNavAndFooter = () => {
  const [showContent, setShowContent] = useState(false);
  const [termsModalOpen, setTermsModalOpen] = useState(false);
  const { language } = useSelector((state) => state.lang);
  const [searchParams] = useSearchParams();
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const homePath = location.pathname.includes('/home');

  const handleOpenTermsModal = () => {
    setTermsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseTermsModal = () => {
    setTermsModalOpen(false);
    document.body.style.overflow = 'auto';
    dispatch(closeTermsModal());
  };

  useEffect(() => {
    const queryLang = searchParams.get('language');
    if (queryLang && queryLang !== language) {
      if (queryLang !== 'ar' && queryLang !== 'en' && queryLang !== 'hr') {
        navigate('404');
      } else {
        i18n.changeLanguage(queryLang);
        dispatch(setLanguage(queryLang));
        setShowContent(true);
      }
    } else {
      setShowContent(true);
    }
  }, [searchParams]);

  return showContent ? (
    <>
      <Navbar onOpenTermsModal={handleOpenTermsModal} />
      <main
      // className={`${!homePath ? 'main-content' : undefined} bg--main-stars`}
      >
        {location.pathname !== '/home' && <HeroSection />}
        <Outlet />
      </main>
      <Footer onOpenTermsModal={handleOpenTermsModal} />
      <TermsModal open={termsModalOpen} onCancel={handleCloseTermsModal} />
    </>
  ) : (
    ''
  );
};

export default LayoutWithNavAndFooter;
